/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2014
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["underscore", "jquery"], function (_, $) {

    return function () {
      var result = _.find(["", "moz", "ms", "o", "webkit"], function (prefix) {
        var el = document.createElement("div"),
            prop = prefix ? prefix + "FlexBasis" : "flexBasis",
            ok;

        document.body.appendChild(el);
        ok = typeof el.style[prop] !== "undefined";
        document.body.removeChild(el);
        return ok;
      });
      if (typeof result !== "undefined") return true;
      
      var available = false,
          el = document.createElement("div"),
          flexEl = document.createElement("div");

      el.style.width = "0";
      el.style.height = "3px";
      el.style.display = "flex";
      el.style.flexDirection = "column";

      flexEl.style.flex = "1";
      el.appendChild(flexEl);

      document.body.appendChild(el);

      if (flexEl.offsetHeight === 3) available = true;

      if (!available) {
        // IE 10
        el.style.display = "-ms-flexbox";
        el.style.MsFlex = "1";
        if (flexEl.offsetHeight === 3) available = true;
      }

      document.body.removeChild(el);

      return available;
    }
});
